import React from 'react';
import { GenericListPage } from '../../components/generic';
import { useSupplierInvoicePayments, SupplierInvoicePayment } from './useData';
import { moduleConfig, getColumns, getTableActions, getToolbarIcon } from './config';

const List: React.FC = () => {
  return (
    <GenericListPage<SupplierInvoicePayment>
      useData={useSupplierInvoicePayments}
      config={{
        ...moduleConfig,
        getColumns,
        getTableActions,
        getToolbarIcon,
      }}
    />
  );
};

export default List;
